var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"genera",staticStyle:{"background-color":"#ffffff"}},[_c('barraNavegacionPublic',{staticClass:"barraNavegacionPublic"}),_vm._v(" "),_c('cuerpo',{staticClass:"cuerpo"}),_vm._v(" "),_c('footerPublic',{staticClass:"footerPublic"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fafa38a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publico/una_categoria.vue
// module id = null
// module chunks = 